module.exports = __webpack_public_path__ + "static/90-5379fd47a197c3047682cbe0c68fa50f.png";